<template>

    <m-edit1/>

    <m-projects-1 v-bind='{...{},...{}}' :style='""' class="" ></m-projects-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mProjects1 from '@moeinmdn/miw-alpha-components/src/package/Dashboard/CRM/Project/Projects1';

export default {
    name: 'HomeView',
    components: {mEdit1, mProjects1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
